module.exports = __webpack_public_path__ + "static/btn-right-vector-e1d77cc2c70d201fce2da0e66552768a.svg";